import { FaUser } from "react-icons/fa";
import { BsUnlock } from "react-icons/bs";

export const dropDownMenuUserList = [
  {
    span: "Mon Profil",
    icon: <FaUser />,
    linkTo: "/mon-profile",
  },

  {
    span: "Changer de mot de passe",
    icon: <BsUnlock />,
    linkTo: "/mon-profile#change-password",
  },
  {
    span: "Se déconnecter",
    linkTo: "/",
  },
];
